export const APICONFIG = {
  // API_BASE_URL: "http://localhost:5001/kerestir-168d8/us-central1/api",
  API_BASE_URL: 'https://us-central1-kerestir-168d8.cloudfunctions.net/api',
};

export const KEY = {
  MAP_KEY: 'AIzaSyAQbkexjOhqAYKHe9RzEK0_M746ykYXJ-c',
};
